var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHover = function SvgHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h142a8 8 0 0 1 8 8v28a8 8 0 0 1-8 8H0V0Z",
    fill: "url(#HOVER_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HOVER_svg__a",
    x1: 60.132,
    y1: 22,
    x2: 0,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F5F8",
    stopOpacity: 0.8
  })))));
};
export { SvgHover as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjQ0IiB2aWV3Qm94PSIwIDAgMTUwIDQ0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHBhdGggZD0iTTAgMEgxNDJDMTQ2LjQxOCAwIDE1MCAzLjU4MTcyIDE1MCA4VjM2QzE1MCA0MC40MTgzIDE0Ni40MTggNDQgMTQyIDQ0SDBWMFoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl80XzE2MykiLz4KICAgIDxkZWZzPgogICAgICAgIDxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl80XzE2MyIgeDE9IjYwLjEzMjIiIHkxPSIyMiIgeDI9Ii00LjE2NjQ1ZS0wNiIgeTI9IjIyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNGM0Y1RjgiLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRjNGNUY4IiBzdG9wLW9wYWNpdHk9IjAuOCIvPgogICAgICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgICA8L2RlZnM+Cjwvc3ZnPgo=";